import TeamworkIcon from './TeamworkIcon'

export default TeamworkIcon
